import { useSnapshot } from 'valtio'
import React, { type FormEvent, type ReactElement, useEffect } from 'react'
import Script from 'next/script'
import { SlideOver } from '../ui/SlideOver'
import { GtagEvents, gtmTrackButtonPress } from '../../utils/gtmUtils'
import { ConvergeLightboxSlideover } from '../ConvergeLightboxSlideover/ConvergeLightboxSlideover'
import {
  resetVirtualTerminalCardAddProxy,
  cardAddProxy
} from './cardAddProxy'
import { CardSectionSlideContents } from './CardSectionSlideContents/CardSectionSlideContents'

const cancelFunction = (): void => {
  cardAddProxy.displaySlideOverCAP = false
  gtmTrackButtonPress(GtagEvents.CARD_MODAL_CANCEL)
  resetVirtualTerminalCardAddProxy()
}

interface Props {
  submitFunction: (e: FormEvent<HTMLFormElement>) => Promise<void>
}
export function CardAddSlideOver ({ submitFunction }: Props): ReactElement {
  const { displaySlideOverCAP, allowSubmitCAP } = useSnapshot(cardAddProxy)
  useEffect(() => resetVirtualTerminalCardAddProxy, [])
  return (
    <SlideOver submitText="Next" canSubmit={allowSubmitCAP} isOpen={displaySlideOverCAP} title="Add Credit Card" cancelFunction={cancelFunction} submitFunction={submitFunction}>
      {/*<Script src={process.env.NEXT_PUBLIC_ELAVON_CHECKOUT_JS_URL} />*/}
      <Script src={process.env.NEXT_PUBLIC_ELAVON_LIGHTBOX_URL} />

      <ConvergeLightboxSlideover />
      <CardSectionSlideContents />
    </SlideOver>
  )
}
